export default __webpack_public_path__ + "8c4d72afae23f2b498c0df46657c9d92.svg";